import React from 'react';

import axios from '../../axios';

import AuthLayout from '../../layouts/AuthLayout';

class Login2 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: props.match.params.token,
      verified: false
    };
  }
  async verifyToken() {
    try {
      let response = await axios.post('verify/verify', {
        token: this.state.token
      });
      if (response.status === 200) {
        this.setState({
          verified: true
        });
        this.props.history.push('/profile');
      }
      this.forceUpdate();
    } catch (error) {}
  }
  componentDidMount() {
    this.verifyToken();
  }
  render() {
    return (
      <AuthLayout asideContent={{ title: 'Verify email.' }}>
        {this.state.verified && (
          <div className="p-5">
            <p>Your account has been verified.</p>
          </div>
        )}
      </AuthLayout>
    );
  }
}

export default Login2;
